module.exports = __webpack_public_path__ + "img/home-page-logos.febfff5c.png";